import type { SVGProps } from 'react';

const SvgChevronNorth = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color}
      d="M21.884 16.884a1.25 1.25 0 0 1-1.768 0L12 8.768l-8.116 8.116a1.25 1.25 0 0 1-1.768-1.768l9-9a1.25 1.25 0 0 1 1.768 0l9 9a1.25 1.25 0 0 1 0 1.768"
    />
  </svg>
);

export default SvgChevronNorth;
